export const DESKTOP_BACKGROUND_SIZE = 'cover';
